import { AppBar, Toolbar } from '@mui/material';
import BreadcrumbPages from '../BreadcrumbPages/BreadcrumbPages';
import { useLocation } from 'react-router-dom';
function NavBar() {
  const pagesToHideSnackbar = ['/login', '/', '/auth/keycloak/landpage', '/signin'];

  const loc = useLocation();
 
  return (
    <>
      {!pagesToHideSnackbar.includes(loc.pathname) && <AppBar position='static' sx={{ mt: 2, mb: 8, boxShadow: 'none', backgroundColor: 'transparent' }}>
        <Toolbar sx={{ justifyContent: 'space-between', backgroundColor: 'inherit' }}>
          <BreadcrumbPages />
        </Toolbar>
      </AppBar>}
    </>
  );
}

export default NavBar;